import React , {Fragment, useState} from 'react';
import   {ReactComponent as TickBlue}  from 'assets/images/svg/tick-blue.svg';
import CommonHeader from 'components/shared/CommonHeader';
import CommonFooter from 'components/shared/CommonFooter';
import { PreviousIcon, NextIcon} from 'components/vectors';
import ArtisteAlternate from 'components/blocks/ArtisteAlternate';
import { Formik } from 'formik';
import Swal from 'sweetalert2';


const HomePage = () => {
    const listItems = [
        'Strategies with confidence',
        'Powerful collection of tools',
        'Promote your content and grow your audience on Pandora'
    ];
    const imageArray = [
        `url('/images/png/wizkid-bg.png') no-repeat 30% 0% scroll`,
        `url('/images/png/carousel-1.jpg') no-repeat 30% 0% scroll`,
        `url('/images/png/carousel-2.jpg') no-repeat 30% 0% scroll`,
        `url('/images/png/carousel-3.jpg') no-repeat 30% 0% scroll`
    ]
    const textArray = [
        'We monitor music on televisions,radios,venues and digital service providers across Nigeria',
        'We know when and where music is played',
        'We have made performance  licensing easier and faster for music users',
        'We provide comprehensive usage reports so that users pay for only the songs they play'
    ]
    const artist1 = [
      {
        image: '/images/png/1.png',
        name: '2face'
      },
      {
        image: '/images/png/2.png',
        name: 'Olamide'
      },
      {
        image: '/images/png/3.png',
        name: 'Niniola'
      },
      {
        image: '/images/png/4.png',
        name: 'Burna Boy'
      },
      {
        image: '/images/png/5.png',
        name: 'Timaya'
      },
    ];

    const artist2 = [
      {
        image: '/images/png/6.png',
        name: 'Tiwa Savage'
      },
      {
        image: '/images/png/7.png',
        name: 'Kizz Daniel'
      },

      {
        image: '/images/png/8.png',
        name: 'PatoranKing'
      },

      {
        image: '/images/png/9.png',
        name: 'Falz'
      },
      {
        image: '/images/png/10.png',
        name: 'Wizkid'
      }
    ];

    const artist3 = [
      {
        image: '/images/png/11.png',
        name: 'Davido'
      },
      {
        image: '/images/png/12.png',
        name: 'Yemi Alade'
      },
      {
        image: '/images/png/13.png',
        name: 'Runtown'
      },
      {
        image: '/images/png/14.png',
        name: 'Wande Coal'
      },
      {
        image: '/images/png/15.png',
        name: 'Harrysong'
      }
    ];
    const [position, setPosition] = useState(0);
    const [hasSubmitted, sethasSubmitted] = useState(false);
    return (
      <div className="page-width">
        <div className="container-fluid ns-home">
          <div className="content-width">
            <Fragment>
              <div className="section-one">
                <div
                  className="carousel col-12 col-md-12 px-0"
                  style={{
                    background: imageArray[position],
                    backgroundSize: 'cover'
                  }}
                >
                  <CommonHeader />
                  <div className="hero-section">
                    <div className="row">
                      <div className="col-2 col-md-2">
                        <div
                          className="carousel-control"
                          onClick={
                            position > 0
                              ? () => {
                                  setPosition(position - 1);
                                }
                              : null
                          }
                        >
                          <PreviousIcon />
                        </div>
                      </div>
                      <div className="col">
                        {/* <div> */}
                        <div className="d-flex flex-row justify-content-around">
                          <h2 className="hero-header text-center">
                            Grow Through the Power of Pandora
                          </h2>
                        </div>
                        <div className="d-flex flex-row justify-content-around">
                          <p
                            className="text--medium text--white hero-info"
                            style={{ transition: 'all 0.3s ease-in-out' }}
                          >
                            {textArray[position]}
                          </p>
                        </div>
                        {/* </div> */}
                      </div>

                      <div className="col-2 col-md-2">
                        <div
                          className="carousel-control"
                          onClick={
                            position < 3
                              ? () => {
                                  setPosition(position + 1);
                                }
                              : null
                          }
                        >
                          <NextIcon />
                        </div>
                      </div>
                    </div>

                    <div className="">
                      <form className="hero-form row">
                        <div className="col-10 mx-auto mx-md-0 col-md-4 ml-md-auto my-3 my-md-0">
                          <input
                            className="nsForm-input large my-0"
                            type="email"
                            placeholder="Enter Email Address"
                          />
                        </div>
                        <div className="col-10 mx-auto mx-md-0 col-md-4 mr-md-auto">
                          <div className="nsForm-btn box box--secondary">
                            <p className="mt-1">Try it for Free</p>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <div className="section-two">
                <div className="row">
                  <div className="d-none d-md-flex col-md-6">
                    <img src="/images/png/homepage-bg2.png" alt="" />
                  </div>
                  <div className="col col-md-4 offset-md-1">
                    <div>
                      <h2 className="col-md-10 px-0 section-two__header">
                        Transparency
                      </h2>
                      <p className="text--medium section-two__info">
                        We monitor over 217 radio and television stations across
                        Nigeria and have developed an impressing device to
                        capture music in public places such as bars,
                        restaurants, malls, hotels, etc. We track the use of
                        music, analyse and collect royalties based on the number
                        of plays. Content owners can now anticipate the amount
                        of royalty due to them from each user
                      </p>
                    </div>
                    <div className="col col-md-10 px-md-0">
                      <div className="row image-container">
                        <div className="col-4 col-md-4 image-wrapper">
                          <img src="/images/svg/mtv.svg" alt="" />
                        </div>
                        <div className="col-4 col-md-4 image-wrapper">
                          <img src="/images/svg/dstv.svg" alt="" />
                        </div>
                        <div className="col-4 col-md-4 image-wrapper">
                          <img src="/images/svg/gotv.svg" alt="" />
                        </div>
                        <div className="col-4 col-md-4 image-wrapper">
                          <img src="/images/svg/bondfm.svg" alt="" />
                        </div>
                        <div className="col-4 col-md-4 image-wrapper">
                          <img src="/images/svg/wazobia.svg" alt="" />
                        </div>
                        <div className="col-4 col-md-4 image-wrapper">
                          <img src="/images/svg/sound963.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="section-three">
                <div className="row">
                  <div className="col col-md-6">
                    <div className="container">
                      <h2 className="section-three__header">Control</h2>
                      <p className="text--medium text--light-grey section-three__info">
                        Content owners can now decide who should play their
                        songs and how much to charge per pay. The rule of the
                        compulsory licence and predetermined royalty rates does
                        not apply to us
                      </p>
                    </div>
                  </div>
                  <div className="d-none d-md-flex col-md-6">
                    <img src="/images/png/release.png" alt="" />
                  </div>
                </div>
              </div>
              <div className="section-four">
                <div className="row">
                  <div className="d-none d-md-flex col-md-6">
                    <img src="/images/png/context.png" alt="" />
                  </div>
                  <div className="col col-md-6">
                    <div className="row">
                      <div className="col-md-7 mr-auto">
                        <div>
                          <h2 className="col-md-9 px-0 section-four__header">
                            Fairness
                          </h2>
                          <p className="text--medium text--light-grey section-four__info">
                            We have moved on from the traditional practice of
                            extrapolating because the outcome is either a
                            copyright holder is underpaid or overpaid for its
                            works. Now, music users pay for only the music that
                            they played while content owners are paid based on
                            the number of times their works were played.
                          </p>

                          <div>
                            <ul className="section-four__list-items">
                              {listItems.map((item, index) => (
                                <li
                                  key={index}
                                  className="section-four__list-item">
                                  <TickBlue className="tick" />
                                  <p className="text--medium text--light-grey">
                                    {item}
                                  </p>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="section-seven" id="licensing">
                <div className="row">
                  <div className="col-md-4 offset-2 mx-auto">
                    <div>
                      <h2 className="col-md-10 px-0 section-seven__header">
                        Licensing
                      </h2>
                      <p className="text--medium section-seven__info">
                        We are committed to making the process of obtaining
                        licence to play music in your place of business seamless
                        by way of direct licensing. This is why we work closely
                        with creators and owners, particularly composers,
                        publishers, record labels, and performing artists. The
                        licence we issue to you grants you the legal
                        authorisation to play all/part of the music we control
                        during the term of your licence. To ensure fairness and
                        make it cheaper, you only pay for the number of times
                        you played each music, not what others that may be
                        playing music more you paid.
                      </p>
                    </div>
                  </div>
                  <div className="d-none d-md-flex col-md-6">
                    <img src="/images/png/release.png" alt="" />
                  </div>
                </div>
              </div>
              <div className="section-eight" id="service">
                <div className="row">
                  <div className="col-md-6  mx-auto">
                    <h3 className="section-eight__header">Our Services</h3>
                    <p className="section-eight__info">
                      We monitor the use of music on service platforms across
                      Nigeria 24 hours a day. Our music televisions, radios,
                      venues and digital identification system leverages on a
                      patented audio fingerprinting technology to recognise
                      millions of songs immediately there are played, whether on
                      airplay or live performance. We currently track over 147
                      radio stations, 70 television channels, 10 digital service
                      providers and over 100 venues, including hotels,
                      restaurants, bars,nightclubs, malls, and event halls.
                    </p>
                    <p className="section-eight__info mt-3">
                      We determine the licence fee for each user based on
                      comprehensive usage reports generated by the
                      identification system. The metadata describes the songs
                      played, when, and number of times. It also identifies the
                      owner(s) of each record played.
                    </p>
                  </div>
                </div>
              </div>
              <div className="section-five">
                <h2 className="section-five__header col-md-6">
                  The alternative solution to the traditional burdensome of
                  music licensing
                </h2>
                <div className="row">
                  <div className="col-md-5 mx-auto">
                    <p className="text--medium text--white section-five__info">
                      We are the innovation that the music industry has long
                      awaited for. The first non-governmental affiliated entity
                      in Nigeria to provide one-stop performance licensing hub
                      for both compositions and masters. Music users can now pay
                      for just the songs they play while musicians are paid for
                      the number of airplays.
                    </p>
                    <div className="row d-flex flex-row my-3">
                      <div className="col-md-6">
                        <input
                          className="nsForm-input alternate"
                          placeholder="Enter Email Address"
                        />
                      </div>
                      <div className="col-md-6 py-2">
                        <div className="nsForm-btn box box-xs box--white">
                          Try if for Free
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="section-six">
                <div className="artiste__container">
                  {artist1.map((artist, index) => (
                    <ArtisteAlternate key={index} {...artist} />
                  ))}
                </div>
                <div className="artiste__container">
                  {artist2.map((artist, index) => (
                    <ArtisteAlternate key={index} {...artist} />
                  ))}
                </div>
                <div className="d-none d-md-flex artiste__container">
                  {artist3.map((artist, index) => (
                    <ArtisteAlternate key={index} {...artist} />
                  ))}
                </div>
                {/* <div className="artiste__container">
                  {artists.splice(11, 14).map((artist, index) => (
                    <ArtisteAlternate key={index} {...artist} />
                  ))}
                </div> */}
                {/* <div className="artiste__container">
                  {[1, 2, 3, 4, 5].map((num, index) => (
                    <ArtisteAlternate key={index} />
                  ))}
                </div> */}
              </div>
              <div className="section-nine" id="about">
                <div className="row">
                  <div className="col-11 col-md-5 mx-auto about">
                    <h3 className="text-larger text--black text-center col-9 mx-auto">
                      How Music & Right is changing the music industry
                    </h3>
                    <p className="text--medium text--light-grey text-center">
                      M & R is a performing right management company founded as
                      an alternative to traditional performance rights
                      management. Our business model is based on technology for
                      accurate output.
                    </p>
                  </div>
                </div>
              </div>
              <div className="section-ten" id="contact">
                <div className="row">
                  <div className="col-md-3 mx-auto">
                    <h3 className="section-ten__header">Contact Us</h3>
                    <ul className="section-ten__list">
                      <li className="section-ten__list-item">
                        Music and Rights,
                      </li>
                      <li className="section-ten__list-item">
                        Plot 110 Oluwakayode Jacobs Street Lekki Phase 1, Lagos
                      </li>
                      <li className="section-ten__list-item">
                        Tel:- 08090605004{' '}
                      </li>
                      <li className="section-ten__list-item">
                        Email:- info@musicandrights.com
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-4 mr-auto">
                    <Formik
                      initialValues={{ email: '', message: '', full_name: '' }}
                      validate={values => {
                        let errors = {};
                        const regexp = new RegExp(
                          /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
                        );
                        sethasSubmitted(false)
                        if (!values.email || !regexp.test(values.email)) {
                          errors.email = true;
                        }

                        if (!values.message) {
                          errors.message = true;
                        }

                        if (!values.full_name) {
                          errors.full_name = true;
                        }
                        return errors;
                      }}
                      onSubmit={(values, { isSubmitting, setSubmitting }) => {
                        setSubmitting(true);

                        fetch(
                          'https://musicandrights.herokuapp.com/api/v1/contact',
                          {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(values)
                          }
                        )
                          .then(res => res.json())
                          .then(res => {
                            setSubmitting(false);
                            if (res.code === 200) {
                              sethasSubmitted(true)
                              Swal.fire({
                                type: 'success',
                                title: '',
                                text: res.data.message
                              })
                            }
                          });
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting
                        /* and other goodies */
                      }) => (
                        <form onSubmit={handleSubmit}>
                          <div className="form-card">
                            {
                              hasSubmitted ? (
                              <p className="text-center nsForm-label my-2">
                                Submitted
                              </p>
                            ) : null}

                            <div>
                              <label className="nsForm-label">Full Name</label>
                              <input
                                placeholder="Enter full name"
                                name="full_name"
                                className={`nsForm-input ${
                                  touched.full_name && errors.full_name
                                    ? 'error'
                                    : null
                                }`}
                                onChange={handleChange}
                              />
                            </div>
                            <div>
                              <label className="nsForm-label">
                                Email Address
                              </label>
                              <input
                                placeholder="Enter full name"
                                name="email"
                                className={`nsForm-input ${
                                  touched.email && errors.email ? 'error' : null
                                }`}
                                onChange={handleChange}
                              />
                            </div>
                            <div>
                              <label className="nsForm-label">Message</label>
                              <textarea
                                placeholder="Enter Message"
                                rows="10"
                                name="message"
                                className={`nsForm-textarea ${
                                  touched.message && errors.message
                                    ? 'error'
                                    : null
                                }`}
                                onChange={handleChange}
                              ></textarea>
                            </div>
                            <div>
                              <button
                                type="submit"
                                className={
                                  isSubmitting
                                    ? `pill pill--secondary`
                                    : `pill pill--grey`
                                }
                                disabled={isSubmitting}
                              >
                                <p>
                                  {isSubmitting
                                    ? 'Sending Message..'
                                    : 'Send Message'}
                                </p>
                              </button>
                            </div>
                          </div>
                        </form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </Fragment>
            <CommonFooter />
          </div>
        </div>
      </div>
    );
}

export default HomePage;